import axios from 'axios';
import EnvJS from "./env";

async function getStore(usuario_url)
{
  return await axios.get( EnvJS.URL_API + 'empresa/' + usuario_url).then(res=>{
    if(res.data){
      return res.data;
    }
  }).catch(error=>{
    return null;
  });
}

export default{
  getStore
}



// WEBPACK FOOTER //
// ./src/api/StoreApi.js